/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Shot_TimingInputs */

const en_ccsl_export_header_shot_timing = /** @type {(inputs: Ccsl_Export_Header_Shot_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Timing`)
};

const fr_ccsl_export_header_shot_timing = /** @type {(inputs: Ccsl_Export_Header_Shot_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing du plan`)
};

const de_ccsl_export_header_shot_timing = /** @type {(inputs: Ccsl_Export_Header_Shot_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schuss-Timing`)
};

const it_ccsl_export_header_shot_timing = /** @type {(inputs: Ccsl_Export_Header_Shot_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempismo di tiro`)
};

const ru_ccsl_export_header_shot_timing = /** @type {(inputs: Ccsl_Export_Header_Shot_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время выполнения удара`)
};

const es_ccsl_export_header_shot_timing = /** @type {(inputs: Ccsl_Export_Header_Shot_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización del disparo`)
};

const zh_cn2_ccsl_export_header_shot_timing = /** @type {(inputs: Ccsl_Export_Header_Shot_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拍摄时机`)
};

const ja_ccsl_export_header_shot_timing = /** @type {(inputs: Ccsl_Export_Header_Shot_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットタイミング`)
};

const hi_ccsl_export_header_shot_timing = /** @type {(inputs: Ccsl_Export_Header_Shot_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट टाइमिंग`)
};

const pt_pt2_ccsl_export_header_shot_timing = /** @type {(inputs: Ccsl_Export_Header_Shot_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização do disparo`)
};

/**
* | output |
* | --- |
* | "Shot Timing" |
*
* @param {Ccsl_Export_Header_Shot_TimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_shot_timing = /** @type {((inputs?: Ccsl_Export_Header_Shot_TimingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Shot_TimingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_shot_timing(inputs)
	if (locale === "de") return de_ccsl_export_header_shot_timing(inputs)
	if (locale === "it") return it_ccsl_export_header_shot_timing(inputs)
	if (locale === "ru") return ru_ccsl_export_header_shot_timing(inputs)
	if (locale === "es") return es_ccsl_export_header_shot_timing(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_shot_timing(inputs)
	if (locale === "ja") return ja_ccsl_export_header_shot_timing(inputs)
	if (locale === "hi") return hi_ccsl_export_header_shot_timing(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_shot_timing(inputs)
	return en_ccsl_export_header_shot_timing(inputs)
});